import { createComponent } from '@carvana/merch-components';

export const CleanVehicleTaxPill = createComponent('div', {
  className:
    'w-fit rounded-full bg-decorative-ev px-8 py-[2px] text-blue-6 tl-header-xs'
});

export const SectionHeaderSmall = createComponent('h3', {
  className: 'items center flex gap-4 text-blue-6 tl-header-xs'
});

export const RequirementsList = createComponent('ul', {
  className: 'mb-0 flex list-none flex-col gap-4 px-4 text-grey-5 tl-body-s'
});

export const NumberedList = createComponent('ol', {
  className:
    'mb-0 flex list-none flex-col gap-4 px-4 text-grey-5 tl-body-s [counter-reset:item]'
});

export const NumberedItem = createComponent('li', {
  className: `
    relative
    flex
    flex-col
    gap-8
    pl-16
    [counter-increment:item]
    before:absolute
    before:left-0
    before:content-[counter(item)")"]
  `
});

export const Bold = createComponent('span', { className: 'font-bold' });
